import { FC } from 'react';
import { InfoTwoTone as InfoIcon } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { RowLabelTooltip } from 'components/RowLabelTooltip';
import { useRevealEllipsisInTooltip } from 'services/hooks';
import { TooltipCellProps } from './TooltipCell.props';
import useTooltipCellStyles from './TooltipCell.styles';

const TooltipCell: FC<TooltipCellProps> = props => {
  const { placement = 'top-end', title, tooltipContent } = props;

  const classes = useTooltipCellStyles();

  const { tooltipRef, width } = useRevealEllipsisInTooltip();

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: 'ref' is not included in current BoxProps, but support is coming in the next Material-UI release.
    <Box ref={tooltipRef} display="flex" justifyContent="space-between" alignItems="center">
      <RowLabelTooltip containerWidth={width} title={title}>
        <span>{title}</span>
      </RowLabelTooltip>

      <Tooltip
        arrow
        classes={{
          tooltip: classes.tooltip,
          arrow: classes.arrow,
          popper: classes.popper,
        }}
        placement={placement}
        title={tooltipContent}>
        <InfoIcon className={classes.icon} />
      </Tooltip>
    </Box>
  );
};

export default TooltipCell;
